import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { LOGO_URL } from '../components/Logo';
import { useLocale } from '../context/LocaleContext';

const AboutUs = () => {
  const { t } = useLocale();
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-5xl mx-auto px-6 py-14" data-testid="about-us-page">
      {/* Brand hero */}
      <section className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-black via-neutral-900 to-black text-white p-10 md:p-16 mb-12">
        <div className="grid md:grid-cols-[240px_1fr] gap-8 items-center relative z-10">
          <img src={LOGO_URL} alt="FERON" className="h-40 md:h-56 w-auto object-contain drop-shadow-[0_0_28px_rgba(34,197,94,0.55)]" />
          <div>
            <h1 className="text-4xl md:text-5xl font-black tracking-tight">{t('aboutTitle')}</h1>
            <p className="text-[#22c55e] font-bold text-sm tracking-[0.35em] mt-3">BY ASENA &amp; HITVANSHI</p>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-white/85">{t('aboutHero')}</p>
          </div>
        </div>
        <div className="absolute -right-24 -top-24 w-72 h-72 rounded-full bg-[#22c55e]/10 blur-3xl" />
      </section>

      {/* Story */}
      <section className="grid md:grid-cols-2 gap-10 mb-14">
        <div>
          <h2 className="text-2xl md:text-3xl font-black mb-4">{t('aboutStoryTitle')}</h2>
          <div className="h-1 w-14 bg-[#22c55e] mb-6" />
          <p className="text-gray-700 leading-relaxed text-[15px]">{t('aboutStoryP1')}</p>
          <p className="text-gray-700 leading-relaxed text-[15px] mt-4">{t('aboutStoryP2')}</p>
        </div>
        <div className="bg-[#f5f5f5] rounded-2xl p-8 border-l-4 border-[#22c55e]">
          <p className="text-lg md:text-xl italic font-semibold text-gray-800 leading-relaxed">{t('aboutQuote')}</p>
          <p className="text-sm font-bold text-[#22c55e] mt-4">— {t('aboutQuoteAttribution')}</p>
        </div>
      </section>

      {/* Values grid */}
      <section className="mb-14">
        <h2 className="text-2xl md:text-3xl font-black text-center mb-2">{t('aboutValuesTitle')}</h2>
        <div className="h-1 w-14 bg-[#22c55e] mx-auto mb-10" />
        <div className="grid md:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="p-6 border rounded-xl bg-white hover:shadow-lg transition" data-testid={`about-value-${i}`}>
              <div className="w-12 h-12 rounded-full bg-[#22c55e]/15 border-2 border-[#22c55e] flex items-center justify-center text-[#22c55e] font-black text-lg mb-4">{i}</div>
              <h3 className="font-black text-lg mb-2">{t(`aboutValue${i}Title`)}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t(`aboutValue${i}Body`)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="text-center bg-black text-white rounded-2xl p-10">
        <h2 className="text-2xl md:text-3xl font-black mb-3">{t('aboutCtaTitle')}</h2>
        <p className="text-white/70 mb-6 max-w-xl mx-auto">{t('aboutCtaBody')}</p>
        <div className="flex gap-3 justify-center flex-wrap">
          <Link to="/shop" className="bg-[#22c55e] hover:bg-[#16a34a] text-black font-black px-8 py-3 rounded-full tracking-wider transition" data-testid="about-cta-shop">
            {t('aboutCtaShop')}
          </Link>
          <Link to="/contact-us" className="border-2 border-white/30 hover:border-white text-white font-black px-8 py-3 rounded-full tracking-wider transition" data-testid="about-cta-contact">
            {t('aboutCtaContact')}
          </Link>
        </div>
      </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutUs;
